import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Login";
import SuperAdminRoutes from "./Routes/SuperAdminRoutes";
import BranchOfficeRoutes from "./Routes/BranchOffice/BranchOfficeRoutes";
import CounsellorRoutes from "./Routes/Counsellor/CounsellorRoutes";
import ApplicationRoute from "./Routes/ApplicationProcessor/ApplicationRoute";
import FrontOfficeRoute from "./Routes/FrontOffice/FrontOfficeRoute";
import StudentLayoutRoute from "./Routes/StudentInfo/StudentLayoutRoute";
import ErrorPage from "./ErrorPage";
import { ToastContainer } from "react-toastify";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />

        {/* User Role-based Routes */}
        <Route path="/super-admin/*" element={<SuperAdminRoutes />} />
        <Route path="/branch-office/*" element={<BranchOfficeRoutes />} />
        <Route path="/counsellor/*" element={<CounsellorRoutes />} />
        <Route path="/application-processor/*" element={<ApplicationRoute />} />
        <Route path="/front-office/*" element={<FrontOfficeRoute />} />
        <Route path="/student-info/*" element={<StudentLayoutRoute />} />
         <Route path="*" element={<ErrorPage />} />
      </Routes>


        <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
     
    </BrowserRouter>
  );
}

export default App;
